<button type="button" matTooltip="Help & Support" [matMenuTriggerFor]="menu" mat-button="">
  <craft-icon class="svg-icon text-size-15" name="general--support-fp"></craft-icon>
</button>

<mat-menu #menu="matMenu">
  <ng-template matMenuContent="">
    <a class="m-item" mat-menu-item="" href="https://help.craft.io/en/collections/2187877-collect-user-feedback" target="_blank">
      <craft-icon class="svg-icon" name="custom--wheel-md"></craft-icon>
      Craft.io Help Center
    </a>
    <button class="m-item" type="button" mat-menu-item="" id="contact-support-button">
      <craft-icon class="svg-icon" name="general--contact"></craft-icon>
      Contact support
    </button>
  </ng-template>
</mat-menu>
